"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleCampaignTiles = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var DEFAULT_CAMPAIGNS = [/*#__PURE__*/_react["default"].createElement("div", {
  key: "MedibankContactCampaign",
  className: "MedibankContact"
}, /*#__PURE__*/_react["default"].createElement("div", {
  className: "callUsText"
}, /*#__PURE__*/_react["default"].createElement("span", null, " Call us on ", /*#__PURE__*/_react["default"].createElement("a", {
  href: "tel:132331"
}, "132 331"), " between 8am and 8pm (AEST) Monday to Friday (except public holidays) ")), /*#__PURE__*/_react["default"].createElement("span", {
  className: "sr-only"
}, "Call us on 132 331 between 8am and 8pm (AEST) Monday to Friday (except public holidays)")), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
  key: "MedibankCampaign1",
  customCssClass: "MedibankCampaign1",
  campaignImageDescription: "Want your first month free?",
  campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/medibank/Medibank_promo_tile_1.png"
}), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
  key: "MedibankCampaign2",
  customCssClass: "MedibankCampaign2",
  campaignImageDescription: "Medibank and ahm health members save 10% on premiums every year. T&Cs apply.",
  campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/medibank/Medibank_promo_tile_2.png"
}), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
  key: "MedibankCampaign3",
  customCssClass: "MedibankCampaign3",
  campaignImageDescription: "Your ticket to extra pet perks",
  campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/Common/MyPetPass_QT_tile_464x400.png"
}), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
  key: "MedibankCampaign4",
  customCssClass: "MedibankCampaign4",
  campaignImageDescription: "GapOnly ready Pet Insurance",
  campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/Common/GapOnly_tile_232x200.png"
}), /*#__PURE__*/_react["default"].createElement("a", {
  key: "MedibankPDS",
  className: "pdsLink",
  target: "_blank",
  rel: "noreferrer",
  href: "https://www.medibank.com.au/pet-insurance/useful-documents"
}, /*#__PURE__*/_react["default"].createElement("span", null, "Click here to view the Product Disclosure Statement"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
  icon: "file-text"
}))];
var VELOCITY_PROMO = 'velocitypet';
var LIVE_BETTER_PROMO = 'livebetter';
var handleCampaignTiles = exports.handleCampaignTiles = function handleCampaignTiles(appliedPromo) {
  return DEFAULT_CAMPAIGNS.map(function (campaign) {
    if (appliedPromo === '' || !appliedPromo) {
      return campaign;
    }
    if (appliedPromo && appliedPromo.length) {
      if (appliedPromo.toLowerCase() === VELOCITY_PROMO) {
        if (campaign.key === 'MedibankCampaign1') {
          return /*#__PURE__*/_react["default"].createElement("a", {
            href: "https://www.medibank.com.au/pet-insurance/c/pet-insurance-velocity/",
            target: "_blank",
            rel: "noreferrer",
            key: "MedibankCampaign1Link",
            "aria-label": "Pet insurance velocity link"
          }, /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
            key: "MedibankCampaign1",
            customCssClass: "MedibankCampaign1",
            campaignImageDescription: "Use promo code VELOCITYTYPE to earn Velocity PointsPlus, Medibank health members save 10% on premiums every year. T&Cs apply.",
            campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/medibank/Velocity_tile.png"
          }));
        }
        if (campaign.key === 'MedibankCampaign2') {
          return /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
            key: "MedibankCampaign2",
            customCssClass: "MedibankCampaign2",
            campaignImageDescription: "Plus, Medibank health members save 10% on premiums every year. T&Cs apply.",
            campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/medibank/Velocity_tile_2.png"
          });
        }
      }
      if (appliedPromo.toLowerCase() === LIVE_BETTER_PROMO && campaign.key === 'MedibankCampaign1') {
        return /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
          key: "CustomCampaign1Only",
          customCssClass: "CustomCampaign1Only",
          campaignImageDescription: "Want to fetch our exclusive health member deal? Sign up using promo code LIVEBETTER. Eligibility criteria & T&Cs apply\u201C?",
          campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/medibank/LIVEBETTER_tile.png"
        });
      }
    }
    return campaign;
  });
};